import { render, staticRenderFns } from "./TestingRequestSample.vue?vue&type=template&id=4c124b78&"
import script from "./TestingRequestSample.vue?vue&type=script&lang=js&"
export * from "./TestingRequestSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestingRequestSample.vue"
export default component.exports